import moment from 'moment';
import { LocaleService } from '../services/storage.service';
/**
 * Возвращает массив с данными для фильтра в формате PG. Даты не принимает.
 * @param {*} obj - объект с данными
 */
const getFilterArray = obj => {
    let arr = [];

    for (let [key, value] of Object.entries(obj)) {
        if (value) {
            if (Array.isArray(value)) {
                if (moment(value[0], 'YYYY-MM-DD', true).isValid() && moment(value[1], 'YYYY-MM-DD', true).isValid()) {
                    arr.push({ field: key, value: `[${value[0]},${value[1]}]` });
                } else if (!value[0] && moment(value[1], 'YYYY-MM-DD', true).isValid()) {
                    arr.push({ field: key, value: `[,${value[1]}]` });
                } else if (moment(value[0], 'YYYY-MM-DD', true).isValid() && !value[1]) {
                    arr.push({ field: key, value: `[${value[0]},]` });
                } else if (!value[0] && !value[1]) {
                    continue;
                } else if (Array.isArray(value) && value.length) {
                    arr.push({ field: key, value: value });
                }
            } else {
                arr.push({ field: key, value: value });
            }

            // if (!Array.isArray(value)) {
            //     arr.push({ field: key, value: value });
            // } else if (Array.isArray(value) && value.length) {
            //     arr.push({ field: key, value: value });
            // }
            //на случай вдруг фильтруемое значение false
        } else {
            if (value === false) arr.push({ field: key, value: value });
            else if (value === 0) arr.push({ field: key, value: value });
        }
    }
    return arr;
};

const getFilterArrayMSSQL = obj => {
    let arr = [];
    for (let [key, value, value2] of Object.entries(obj)) {
        if (value) {
            if (Array.isArray(value)) {
                if (moment(value[0], 'YYYY-MM-DD', true).isValid() && moment(value[1], 'YYYY-MM-DD', true).isValid()) {
                    arr.push({ field: key, value: value[0], value2: value[1] });
                } else if (!value[0] && moment(value[1], 'YYYY-MM-DD', true).isValid()) {
                    arr.push({ field: key, value: value[0], value2: value[1] });
                } else if (moment(value[0], 'YYYY-MM-DD', true).isValid() && !value[1]) {
                    arr.push({ field: key, value: value[0], value2: value[1] });
                } else if (!value[0] && !value[1]) {
                    continue;
                } else if (Array.isArray(value)) {
                    const arrStr = JSON.stringify(value);
                    arr.push({ field: key, value: arrStr.substring(1, arrStr.length - 1) });
                }
            } else {
                arr.push({ field: key, value: value });
            }

            // if (!Array.isArray(value)) {
            //     arr.push({ field: key, value: value });
            // } else if (Array.isArray(value) && value.length) {
            //     arr.push({ field: key, value: value });
            // }
        }
    }
    return arr;
};

const getFilterObject = (options, filter_data) => {
    const locale = LocaleService.getLocale();
    // определяем язык интерфейса
    const JSONToSend = {
        locale: locale === 'ru' ? '___ru' : '___kz'
    };
    // Если задана сортировака
    if (options.sortBy[0]) {
        JSONToSend.order = [{ field: options.sortBy[0], order_by: options.sortDesc[0] === true ? 'desc' : 'asc' }];
    }
    // если задан фильтр
    if (filter_data) {
        JSONToSend.where = filter_data.where;
    }
    return JSONToSend;
};

const formatFilter = (options, filter) => {
    const JSONToSend = {
        locale: `___${LocaleService.getLocale()}`
    };
    if (options.sortBy[0]) {
        JSONToSend.order = [{ field: options.sortBy[0], order_by: options.sortDesc[0] ? 'desc' : 'asc' }];
    }

    if (filter) {
        JSONToSend.where = filter;
    }

    return JSONToSend;
};

/**
 * Возвращает массив с датами для фильтра в PG. Принимает только даты
 * @param {*} obj - объект с данными в виде даты
 */
const getFilterArrayWithDates = obj => {
    let arr = [];
    for (let [key, value] of Object.entries(obj)) {
        if (value[0] && value[1]) {
            arr.push({ field: key, value: `[${value[0]},${value[1]}]` });
        } else if (!value[0] && value[1]) {
            arr.push({ field: key, value: `[,${value[1]}]` });
        } else if (value[0] && !value[1]) {
            arr.push({ field: key, value: `[${value[0]},]` });
        }
    }
    return arr;
};

export { getFilterArray, getFilterArrayMSSQL, getFilterArrayWithDates, getFilterObject, formatFilter };
